import React from 'react';

interface FilterAndSearchProps {
  activeFilter: 'all' | 'active' | 'inactive';
  searchQuery: string;
  onFilterChange: (filter: 'all' | 'active' | 'inactive') => void;
  onSearchChange: (query: string) => void;
}

const FilterAndSearch: React.FC<FilterAndSearchProps> = ({
  activeFilter,
  searchQuery,
  onFilterChange,
  onSearchChange,
}) => {
  return (
    <div className="d-flex justify-content-start align-items-center gap-2 mb-3">
      <div>
        <label className="me-5">Filter by Status: </label>
        <div
          className="btn-group"
          role="group"
          aria-label="Service Status Filter"
        >
          {['all', 'active', 'inactive'].map((filter) => (
            <span
              key={filter}
              className={`badge rounded-pill ${activeFilter === filter ? 'bg-primary' : 'bg-secondary'} me-2 px-4 py-2 cursorPointer`}
              onClick={() =>
                onFilterChange(filter as 'all' | 'active' | 'inactive')
              }
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </span>
          ))}
        </div>
      </div>
      <div>
        <input
          type="text"
          placeholder="Search by title or description"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="form-control w-300px"
        />
      </div>
    </div>
  );
};

export default FilterAndSearch;
